import React from 'react'
import {
  Dialog,
  DialogContent,
  Backdrop,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  DialogTitle,
  makeStyles
} from '@material-ui/core'
import axios from 'axios'
import { ResetRestrictionLog } from '../../types/ResetRestrictionLog'
import moment from 'moment'
import { Clear } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  flexRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  clearIcon: {
    fontSize: '26px',
    cursor: 'pointer'
  }
}))

const ResetRestrictionLogModal: React.FC<{
  kaiinNo: string
  isOpen: boolean
  closeHandler: () => void
}> = ({ kaiinNo, isOpen, closeHandler }) => {
  const classes = useStyles()
  const handleClose = () => {
    setLogs([])
    closeHandler()
  }

  const [logs, setLogs] = React.useState<ResetRestrictionLog[]>([])

  const fetch = React.useCallback(async () => {
    if (kaiinNo) {
      const { data } = await axios.get<ResetRestrictionLog[]>(
        `users/kaiin/${kaiinNo}/reset-restriction-logs`
      )
      setLogs(data)
    }
  }, [kaiinNo])

  React.useEffect(() => {
    fetch()
  }, [fetch])

  return (
    <Dialog
      maxWidth="lg"
      open={isOpen}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      closeAfterTransition
    >
      <div className={classes.flexRight}>
        <Clear className={classes.clearIcon} onClick={handleClose} color="primary" />
      </div>
      <DialogTitle>解除履歴</DialogTitle>
      <DialogContent style={{ minHeight: 100 }}>
        <Table style={{ minWidth: 500 }}>
          <TableHead>
            <TableRow>
              <TableCell>管理者</TableCell>
              <TableCell>解除日時</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map(log => (
              <TableRow key={log.id}>
                <TableCell align="left">{log.created_by}</TableCell>
                <TableCell align="left">
                  {moment(log.created_at).format('YYYY/MM/DD HH:mm')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  )
}

export default ResetRestrictionLogModal
